import React from 'react';

import { useLocation } from 'react-router-dom';
import {
  SocialButtonContainer,
  SocialButtonIcon,
  SocialIcon,
  SociaButtonTitle,
} from '../styles';

const FACEBOOK_BUTTON = { bg: '#3b5998', icon: 'facebook', name: 'Facebook' };

const FacebookButton = () => {
  const { bg, icon, name } = FACEBOOK_BUTTON;

  const { pathname } = useLocation();

  const signText = pathname.includes('sign-up') ? 'Sign Up' : 'Sign In';
  const buttonText = `${signText} with ${name}`;

  const handleClick = () => {
    const [facebookBtn] = document.querySelectorAll('[data-oauth-command="fbidentity.call"]');
    if (facebookBtn) facebookBtn.click();
  };

  return (
    <SocialButtonContainer bg={bg} onClick={handleClick} provider="fbidentity">
      <SocialButtonIcon>
        <SocialIcon name={icon} />
      </SocialButtonIcon>
      <SociaButtonTitle>
        {buttonText}
      </SociaButtonTitle>
    </SocialButtonContainer>
  );
};

export default FacebookButton;
